export default __webpack_public_path__ + "static/media/ps-t-scores.6316ecd4.png";